import TwoFactorFeature from '../../components/features/2fa/TwoFactorAuth';

const TwoFactorAuth = () => (
  <>
    <div className="flex flex-col gap-10 h-full">
      <TwoFactorFeature />
    </div>
  </>
);

export default TwoFactorAuth;
